import { useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

// Dados da clínica (GET/PUT), thumbnail e upload do logo no quarkus.
export function useClinicSettings() {
  const fetchClinic = useCallback(() => quarkusApi.get('/clinic', authHeader()), []);

  const saveClinic = useCallback((payload) => quarkusApi.put('/clinic', payload, authHeader()), []);

  const fetchLogoThumbnail = useCallback(
    () => quarkusApi.get('/clinic/logo/thumbnail', authHeader()),
    [],
  );

  const uploadLogo = useCallback(
    (formData) => quarkusApi.post('/clinic/logo', formData, authHeader()),
    [],
  );

  return { fetchClinic, saveClinic, fetchLogoThumbnail, uploadLogo };
}
